import { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import styles from "./styles/radiogroup.module.css";

export function RadioGroup(props) {
  const { name, selectedValue, onClickRadioButton, children, ...rest } = props;
  return (
    <div className={styles.box} role="radiogroup" name={name}>
      {Children.map(children, (element) => {
        const handleClick = (e) => {
          onClickRadioButton(element.props)
        }

        return cloneElement(element, {
          ...element.props,
          checked: selectedValue === element.props.value,
          onChange: handleClick,
          name,
        });
      })}
    </div>
  );
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  selectedValue: PropTypes.string.isRequired,
  onClickRadioButton: PropTypes.func.isRequired,
};
